export const A_SEARCH_PARAM = 'a_search';
export const COVERAGE_PARAM = 'coverage';
